module.exports = __webpack_public_path__ + "img/study.5d5a0e41.jpg";